import {
  Reward,
  CustomerData,
  ClaimedReward,
  TransactionDto,
  CouponCodeDto,
  ProfileFormStateDto,
  ProfileFormValidationErrorDto,
} from "src/app/services/api";
import { Platform } from "src/app/enums";

export type Rewards = Record<string, Reward>;

export type ClaimedRewards = Record<string, ClaimedReward>;

export interface UTM {
  utmCampaign?: string;
  utmSource?: string;
  utmMedium?: string;
}

export interface ProfileFormState {
  data: ProfileFormStateDto | null;
  loading: boolean;
  /** Section whose save is in flight. */
  savingSectionId: string | null;
  /** Field errors of the last rejected save (400 `PROFILE_FORM_INVALID`). */
  errors: ProfileFormValidationErrorDto[];
  /** The merchant changed the form while the customer was answering it (409); it was reloaded. */
  outdated: boolean;
  error: string | null;
}

export const initialProfileFormState: ProfileFormState = {
  data: null,
  loading: false,
  savingSectionId: null,
  errors: [],
  outdated: false,
  error: null,
};

export interface UserState {
  customerData: CustomerData;
  rewards: Rewards;
  claimedRewards: ClaimedRewards;
  authToken: string;
  downloadToken: string;
  verifyToken: string;
  userId: string;
  referral: string;
  utm: UTM;
  error: string;
  errorParams: Record<string, unknown>;
  transactions: TransactionDto[];
  customerCodes: CouponCodeDto[];
  profileForm: ProfileFormState;
  /** Own flag so the codes request doesn't end the loading of the rewards it runs alongside. */
  customerCodesLoading: boolean;
  /** Wallet the coupon pass is being requested for, so only that button shows the loading. */
  downloadingCouponPass: Platform | null;
  loading: boolean;
}

export const initialState: UserState = {
  customerData: null,
  rewards: {},
  claimedRewards: {},
  authToken: null,
  downloadToken: null,
  verifyToken: null,
  userId: null,
  referral: undefined,
  utm: {
    utmCampaign: undefined,
    utmSource: undefined,
    utmMedium: undefined,
  },
  error: null,
  errorParams: {},
  loading: false,
  transactions: [],
  customerCodes: [],
  profileForm: initialProfileFormState,
  // Codes are pending until their first request finishes, so the coupons page doesn't flash the empty state.
  customerCodesLoading: true,
  downloadingCouponPass: null,
};

export const persistedKeys: (keyof UserState)[] = [
  "authToken",
];
